<template>
  <div class="promotion-ticket-table">
    <div class="table-header">
      <h4>Danh sách vé khuyến mãi</h4>
    </div>
    <table class="ticket-list-table">
      <thead>
        <tr>
          <th>Vé mua</th>
          <th>Loại vé mua</th>
          <th>SL vé mua</th>
          <th>Vé giảm giá</th>
          <th>Loại vé giảm giá</th>
          <th>SL vé giảm giá</th>
          <th>% giảm giá</th>
          <th>
            <button
              type="button"
              class="btn-icon btn-add"
              @click="handleAddRow"
            >
              +
            </button>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(item, index) in localTicketList"
          :key="index"
          :class="{ 'row-duplicate': duplicateRows.has(index) }"
        >
          <td>
            <div v-if="duplicateRows.has(index)" class="duplicate-warning">
              <i class="el-icon-warning" /> Vé mua và loại vé mua bị trùng
            </div>
            <validation-provider
              rules="required"
              :name="`Vé mua hàng ${index + 1}`"
            >
              <el-select
                :key="`ticket_${index}_${item.ticket}`"
                :value="item.ticket"
                placeholder="Chọn vé"
                clearable
                @change="(val) => handleFieldChange(index, 'ticket', val)"
              >
                <el-option
                  v-for="typeItem in ticketTypeOptions"
                  :key="typeItem.id"
                  :value="typeItem.id"
                  :label="typeItem.name"
                >
                </el-option>
              </el-select>
            </validation-provider>
          </td>
          <td>
            <el-select
              :key="`ticket_type_${index}_${item.ticket_type}`"
              :value="item.ticket_type"
              placeholder="Chọn loại vé"
              clearable
              @change="(val) => handleFieldChange(index, 'ticket_type', val)"
            >
              <el-option
                :value="1"
                label="Người lớn"
              >
              </el-option>
              <el-option
                :value="2"
                label="Trẻ em"
              >
              </el-option>
              <el-option
                :value="null"
                label="Không phân biệt"
              >
              </el-option>
            </el-select>
          </td>
          <td>
            <validation-provider
              rules="required|min_value:1|integer"
              :name="`SL vé mua hàng ${index + 1}`"
            >
              <input
                v-model="item.ticket_num"
                v-numeric-only
                type="text"
                placeholder="Số lượng"
                @input="(e) => handleFieldChange(index, 'ticket_num', e.target.value)"
              />
            </validation-provider>
          </td>
          <td>
            <validation-provider
              rules="required"
              :name="`Vé giảm giá hàng ${index + 1}`"
            >
              <el-select
                :key="`ticket_discount_${index}_${item.ticket_discount}`"
                :value="item.ticket_discount"
                placeholder="Chọn vé"
                clearable
                @change="(val) => handleFieldChange(index, 'ticket_discount', val)"
              >
                <el-option
                  v-for="typeItem in ticketTypeOptions"
                  :key="typeItem.id"
                  :value="typeItem.id"
                  :label="typeItem.name"
                >
                </el-option>
              </el-select>
            </validation-provider>
          </td>
          <td>
            <el-select
              :key="`ticket_discount_type_${index}_${item.ticket_discount_type}`"
              :value="item.ticket_discount_type"
              placeholder="Chọn loại vé"
              clearable
              @change="(val) => handleFieldChange(index, 'ticket_discount_type', val)"
            >
              <el-option
                :value="1"
                label="Người lớn"
              >
              </el-option>
              <el-option
                :value="2"
                label="Trẻ em"
              >
              </el-option>
              <el-option
                :value="null"
                label="Không phân biệt"
              >
              </el-option>
            </el-select>
          </td>
          <td>
            <validation-provider
              rules="required|min_value:1|integer"
              :name="`SL vé giảm giá hàng ${index + 1}`"
            >
              <input
                v-model="item.ticket_discount_num"
                v-numeric-only
                type="text"
                placeholder="Số lượng"
                @input="(e) => handleFieldChange(index, 'ticket_discount_num', e.target.value)"
              />
            </validation-provider>
          </td>
          <td>
            <validation-provider
              rules="required|min_value:1|max_value:100|integer"
              :name="`% giảm giá hàng ${index + 1}`"
            >
              <input
                v-model="item.discount"
                v-numeric-only
                type="text"
                placeholder="%"
                min="1"
                max="100"
                @input="(e) => handleFieldChange(index, 'discount', e.target.value)"
              />
            </validation-provider>
          </td>
          <td>
            <button
              type="button"
              class="btn-icon btn-remove"
              :disabled="localTicketList.length <= 1"
              @click="handleRemoveRow(index)"
            >
              -
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'PromotionTicketListTable',
  props: {
    ticketList: {
      type: Array,
      required: true,
      default: () => []
    },
    ticketTypeOptions: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data() {
    return {
      localTicketList: []
    }
  },
  computed: {
    duplicateRows() {
      const seen = {}
      const duplicates = new Set()
      this.localTicketList.forEach((item, index) => {
        const key = `${item.ticket ?? '__null__'}_${item.ticket_type ?? '__null__'}`
        if (seen[key] !== undefined) {
          duplicates.add(seen[key])
          duplicates.add(index)
        } else {
          seen[key] = index
        }
      })
      return duplicates
    }
  },
  watch: {
    ticketList: {
      immediate: true,
      deep: true,
      handler(newVal) {
        // Tạo deep copy để đảm bảo reactivity
        this.localTicketList = JSON.parse(JSON.stringify(newVal || []))
      }
    }
  },
  methods: {
    handleFieldChange(index, field, value) {
      // DEBUG: Log khi một giá trị được chọn trong el-select
      console.log(`DEBUG: handleFieldChange - index: ${index}, field: ${field}, value:`, value)
      console.log(`DEBUG: localTicketList[${index}] before update:`, JSON.parse(JSON.stringify(this.localTicketList[index])))

      if (this.localTicketList[index]) {
        // Cập nhật giá trị trong localTicketList
        this.$set(this.localTicketList[index], field, value)

        // DEBUG: Log sau khi cập nhật
        console.log(`DEBUG: localTicketList[${index}] after update:`, JSON.parse(JSON.stringify(this.localTicketList[index])))

        // Emit event để component cha cập nhật formData
        this.$emit('update-field', {
          index,
          field,
          value,
          updatedList: JSON.parse(JSON.stringify(this.localTicketList))
        })
      }
    },
    handleAddRow() {
      console.log('DEBUG: handleAddRow - Adding new row')
      console.log('DEBUG: Current localTicketList length:', this.localTicketList.length)

      // Thêm hàng mới vào đầu tiên trong localTicketList
      const newRow = {
        ticket: null,
        discount: null,
        ticket_type: null,
        ticket_num: 0,
        ticket_discount: null,
        ticket_discount_type: null,
        ticket_discount_num: 0
      }

      this.localTicketList.unshift(newRow)
      console.log('DEBUG: After adding row, localTicketList length:', this.localTicketList.length)
      console.log('DEBUG: Updated localTicketList:', JSON.parse(JSON.stringify(this.localTicketList)))

      // Emit event với updatedList để component cha cập nhật
      this.$emit('add-row', {
        updatedList: JSON.parse(JSON.stringify(this.localTicketList))
      })
    },
    handleRemoveRow(index) {
      console.log('DEBUG: handleRemoveRow - Removing row at index:', index)
      console.log('DEBUG: Current localTicketList length:', this.localTicketList.length)
      console.log('DEBUG: Current localTicketList:', JSON.parse(JSON.stringify(this.localTicketList)))

      if (this.localTicketList.length > 1) {
        this.localTicketList.splice(index, 1)
        console.log('DEBUG: After removing row, localTicketList length:', this.localTicketList.length)
        console.log('DEBUG: Updated localTicketList:', JSON.parse(JSON.stringify(this.localTicketList)))

        // Emit event với updatedList để component cha cập nhật
        this.$emit('remove-row', {
          index,
          updatedList: JSON.parse(JSON.stringify(this.localTicketList))
        })
      } else {
        console.log('DEBUG: Cannot remove row - only one row remaining')
      }
    }
  }
}
</script>

<style scoped>
.promotion-ticket-table {
  width: 100%;
  margin-top: 1rem;
  max-height: 400px;
  overflow-y: auto;
  overflow-x: auto;
}

/* Custom scrollbar styling */
.promotion-ticket-table::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.promotion-ticket-table::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.promotion-ticket-table::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.promotion-ticket-table::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.table-header {
  margin-bottom: 0.5rem;
}

.table-header h4 {
  margin: 0;
  font-weight: 600;
  font-size: 16px;
  color: #303133;
}

.ticket-list-table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #e0e0e0;
}

.ticket-list-table thead {
  background-color: #e8f5e9;
  position: sticky;
  top: 0;
  z-index: 10;
}

.ticket-list-table thead th {
  padding: 8px;
  text-align: left;
  border: 1px solid #e0e0e0;
  font-weight: 600;
  font-size: 14px;
  color: #000;
}

.ticket-list-table thead th:nth-child(1) {
  width: 22%;
}

.ticket-list-table thead th:nth-child(2) {
  width: 14%;
}

.ticket-list-table thead th:nth-child(3) {
  width: 8%;
}

.ticket-list-table thead th:nth-child(4) {
  width: 22%;
}

.ticket-list-table thead th:nth-child(5) {
  width: 14%;
}

.ticket-list-table thead th:nth-child(6) {
  width: 8%;
}

.ticket-list-table thead th:nth-child(7) {
  width: 8%;
}

.ticket-list-table thead th:nth-child(8) {
  width: 4%;
}

.ticket-list-table tbody tr {
  border-bottom: 1px solid #e0e0e0;
  transition: background-color 0.2s;
}

.ticket-list-table tbody tr:hover {
  background-color: #fafafa;
}

.ticket-list-table tbody td {
  padding: 8px;
  border: 1px solid #e0e0e0;
  vertical-align: middle;
}

.ticket-list-table tbody td:nth-child(1),
.ticket-list-table tbody td:nth-child(4) {
  min-width: 180px;
}

.ticket-list-table tbody td:nth-child(3),
.ticket-list-table tbody td:nth-child(6),
.ticket-list-table tbody td:nth-child(7) {
  width: 80px;
  min-width: 80px;
  max-width: 80px;
}

.ticket-list-table tbody td:nth-child(8) {
  width: 50px;
  min-width: 50px;
  max-width: 50px;
  text-align: center;
}

.ticket-list-table tbody td input,
.ticket-list-table tbody td .el-select {
  width: 100%;
}

.ticket-list-table tbody td input {
  padding: 8px 12px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  font-size: 14px;
  transition: border-color 0.2s;
}

.ticket-list-table tbody td input:focus {
  outline: none;
  border-color: #409eff;
}

.ticket-list-table tbody td .el-select {
  font-size: 14px;
}

.btn-icon {
  padding: 4px 8px;
  margin: 0 2px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background-color: #fff;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  transition: all 0.2s;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  height: 32px;
}

.btn-icon:hover:not(:disabled) {
  background-color: #ecf5ff;
  border-color: #b3d8ff;
}

.btn-icon:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn-icon.btn-add {
  color: #67c23a;
  border-color: #67c23a;
}

.btn-icon.btn-add:hover:not(:disabled) {
  background-color: #f0f9ff;
  border-color: #67c23a;
}

.btn-icon.btn-remove {
  color: #f56c6c;
  border-color: #f56c6c;
}

.btn-icon.btn-remove:hover:not(:disabled) {
  background-color: #fef0f0;
  border-color: #f56c6c;
}

.row-duplicate {
  background-color: #fff8e1 !important;
}

.duplicate-warning {
  color: #e6a23c;
  font-size: 12px;
  margin-bottom: 4px;
  display: flex;
  align-items: center;
  gap: 4px;
}
</style>
